/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

type UndockListItemProps = {
  handleUndock: () => void;
  closeMenu: () => void;
};

const UndockListItem = (props: UndockListItemProps) => {
  const { t } = useTranslation();

  const { handleUndock, closeMenu } = props;

  const handleClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    closeMenu();
    handleUndock();
  };

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>
        <OpenInNewIcon color="primary" fontSize="small" />
      </ListItemIcon>
      <ListItemText>{t('buttons.undock')}</ListItemText>
    </MenuItem>
  );
};

export default UndockListItem;
